export default function Hero() {
  return (
    <section className="relative w-full min-h-[620px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Aesthetic%20flat%20lay%20product%20photography%20arrangement%20with%20diverse%20fashion%20items%20including%20sneakers%20hoodies%20bags%20and%20accessories%20on%20warm%20terracotta%20toned%20surface%2C%20soft%20diffused%20natural%20window%20lighting%20from%20left%20side%2C%20editorial%20magazine%20style%20composition%20with%20organized%20chaos%20aesthetic%2C%20clean%20modern%20European%20styling%2C%20subtle%20linen%20fabric%20texture%20beneath%20items%2C%20shallow%20depth%20of%20field%20on%20edges%2C%20high%20end%20commercial%20photography%20quality&width=1600&height=900&seq=hero-main-bg-v2&orientation=landscape"
          alt="Basetao Spreadsheet resource center with curated fashion products"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/40"></div>
      </div>
      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <div className="inline-flex items-center gap-2 bg-white/90 backdrop-blur-sm rounded-full px-4 py-2 mb-6">
          <span className="w-2 h-2 rounded-full bg-accent-500 animate-pulse"></span>
          <span className="text-xs font-medium text-foreground-800">Updated for 2026 — Fresh Basetao Spreadsheet Resources</span>
        </div>
        <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6">
          Basetao Spreadsheet
          <br />
          <span className="text-accent-200">The Ultimate Guide For Smarter Shopping</span>
        </h1>
        <p className="text-base md:text-lg text-white/85 max-w-2xl mx-auto mb-10 leading-relaxed">
          Discover the latest Basetao spreadsheet resources, product finds, shipping information, warehouse guides, discount opportunities, and expert reviews — all in one place.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto bg-primary-500 text-white font-semibold text-base px-8 py-3.5 rounded-full hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer shadow-lg shadow-primary-500/25 hover:shadow-primary-500/40"
          >
            Basetao Spreadsheet
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto bg-white/95 text-foreground-900 font-semibold text-base px-8 py-3.5 rounded-full hover:bg-white transition-all duration-300 whitespace-nowrap cursor-pointer backdrop-blur-sm"
          >
            Buy It Now
          </a>
        </div>
        <div className="flex flex-wrap items-center justify-center gap-6 mt-10">
          {['Updated Information', 'Beginner Friendly Guides', 'Shipping Cost Analysis', 'Safety Verified'].map((item) => (
            <div key={item} className="flex items-center gap-2 text-white/90">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-check-line text-accent-400 text-sm"></i>
              </div>
              <span className="text-sm font-medium whitespace-nowrap">{item}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}